import footer from '@/components/elements/footer'
import header from '@/components/elements/header'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalWelcome from '@/components/elements/ModalWelcome'
import ViewPackage from '@/components/view/setting/ViewPackage'
import moment from 'moment'
import dropdown from 'vue-dropdowns'
import { mapGetters } from 'vuex'

import api from '@/api'

export default {
  // name: "dashboard",
  components: {
    'app-header': header,
    'app-footer': footer,
    dropdown,
    ViewPackage,
    ModalDialog,
    ModalWelcome
  },
  computed: {
    toacrmagentmanagement() {
      return (
        ['toacrm'].includes(this.selectedBot.theme) &&
        this.$store.state.privilege.role == 'superadmin'
      )
    },
    mitsuWebchatAgentmanagement() {
      return (
        ['mitsuwebchat'].includes(this.selectedBot.theme) &&
        this.$store.state.privilege.role == 'superadmin'
      )
    },
    nestleAcommerceGroup() {
      return (
        ['nestle'].includes(this.selectedBot.type) &&
        this.$store.state.admingroupid &&
        this.$store.state.admingroupid === '420'
      )
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isSelectedBot: 'isSelectedBot',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang',
      showModalWelcome: 'showModalWelcome'
    }),
    isTicket2agent() {
      if (
        ['studio7', 'ticket2', 'ustore'].includes(this.selectedBot.theme) &&
        ['agent', 'superadmin'].includes(this.$store.state.privilege.role)
      ) {
        return true
      } else return false
    },
    pluginMenu() {
      if (this.selectedBot.theme == 'bblcareer') {
        return 'Job Applicants'
      } else if (this.selectedBot.theme == 'grampablokof') {
        return 'Membership'
      } else if (this.selectedBot.theme == 'tero') {
        return 'Questionaire'
      } else if (this.selectedBot.theme == 'toacrm' || this.selectedBot.theme == 'toaecoupon') {
        return 'Reward manager'
      } else if (this.selectedBot.theme == 'plern') {
        return 'Voucher Code'
      } else {
        return 'Plug-In'
      }
    },
    isDefaultTheme() {
      return this.$vuetify.theme.primary == '#FF706B'
    },
    isPremiumExpired() {
      let expire = this.$store.state.selectedBot.expireat
      let today = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS')
      let register = this.$store.state.selectedBot.registerat
      return expire > register && expire < today
    },
    showUpsell1: function () {
      if (this.$store.getters.showAlert('upsell1') >= 0) {
        var alert = this.$store.getters.showAlert('upsell1')
        return alert.show
      } else {
        return true
      }
    },
    showAlertLine: function () {
      if (this.$store.getters.showAlert('line') >= 0) {
        var alert = this.$store.getters.showAlert('line')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPackage: function () {
      if (this.$store.getters.showAlert('expriedPackage') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPackage')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPremium: function () {
      if (this.$store.getters.showAlert('expriedPremium') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPremium')
        return alert.show
      } else {
        return true
      }
    },
    optionBotlist: function () {
      return this.botlist
        .map((el) => {
          if (el.pageid == this.selectedBot.pageid) return null
          return { name: el.pagename, value: el.pageid }
        })
        .filter((el) => {
          return el != null
        })
        .sort((a, b) => {
          var nameA = a.name.toUpperCase() // ignore upper and lowercase
          var nameB = b.name.toUpperCase() // ignore upper and lowercase
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
    },
    filterBotlist: function () {}
  },
  data: function () {
    return {
      drawer: null,
      showAds: true,
      autostart: false,
      introConfig: {
        nextLabel: this.$t('Next'),
        prevLabel: this.$t('Back'),
        skipLabel: this.$t('skip'),
        doneLabel: this.$t('Finish')
      },
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      showMenu: false,
      x: 0,
      y: 0,
      currentBot: null,
      pagelist: [],
      selectedOption: {},
      expriedTime: null,
      expriedDate: null
    }
  },

  methods: {
    isShowMenu(menu) {
      // welcome
      // conversation
      // comment
      // broadcast
      // template
      // livechat
      // dashboard
      // training
      // billing
      if (this.selectedBot.theme == 'scgdistribution') {
        return !['training'].includes(menu)
      }
      if (this.selectedBot.theme == 'kingkitchen') {
        if (
          this.$store.state.privilege &&
          (this.$store.state.privilege.role === 'so' ||
            this.$store.state.privilege.role === 'installation')
        ) {
          return ['admin_menu'].includes(menu)
        } else {
          return true
        }
      } else if (
        this.$store.state.toacustomerpage.includes(this.selectedBot.pageid) &&
        ['TOAadminliveChat01', 'TOAadminliveChat02'].includes(this.$store.state.userid)
      ) {
        return ['livechat'].includes(menu)
      } else if (this.selectedBot.theme == 'toacrm') {
        if (this.$store.state.privilege && this.$store.state.privilege.role == 'superadmin') {
          return true
        } else if (this.$store.state.privilege && this.$store.state.privilege.role === 'admin') {
          return ['template', 'livechat'].includes(menu)
        } else {
          return ['template'].includes(menu)
        }
      } else if (['toaecoupon'].includes(this.selectedBot.theme)) {
        /*  admin
        trade
        approval
        approver1
        approver2
        superadmin */
        if (
          this.$store.state.privilege &&
          ['admin', 'trade', 'approval', 'approver1', 'approver2', 'superadmin'].includes(
            this.$store.state.privilege.role
          )
        ) {
          return true
        } else return false
        // } else if ([...this.$store.state.toaPaintPage].includes(this.selectedBot.pageid)) {
        //   return !['template'].includes(menu)
      } else if (
        ['studio7', 'ticket2', 'ustore'].includes(this.selectedBot.theme) ||
        [...this.$store.state.toaPaintPage].includes(this.selectedBot.pageid)
      ) {
        if (this.$store.state.privilege) {
          if (this.$store.state.privilege.role == 'agent') {
            if (this.selectedBot.theme == 'ustore') {
              return ['profile', 'ticketmanagement', 'livechat', 'dashboard'].includes(menu)
            } else {
              return ['profile', 'ticketmanagement', 'livechat'].includes(menu)
            }
          } else if (this.$store.state.privilege.role == 'chatbot') {
            return !['profile', 'ticketmanagement', 'agentmanagement', 'template'].includes(menu)
          } else if (this.$store.state.privilege.role == 'superadmin') {
            return [
              'profile',
              'ticketmanagement',
              'livechat',
              'agentmanagement',
              'dashboard'
            ].includes(menu)
          } else if (this.$store.state.privilege.role == 'systemadmin') {
            return !['template'].includes(menu)
          }
        } else return ['livechat'].includes(menu)
      } else if (
        this.selectedBot.theme == 'ticket' ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
      ) {
        if (this.$store.state.privilege && this.$store.state.privilege.agent_management) {
          if (this.$store.state.ticketPageid.includes(this.selectedBot.pageid)) {
            return !['template'].includes(menu)
          } else {
            return true
          }
        } else {
          if ([...this.$store.state.oceanlifePage].includes(this.selectedBot.pageid)) {
            return ['livechat', 'dashboard'].includes(menu)
          } else if (this.nestleAcommerceGroup) {
            //group acommerce
            return ['template'].includes(menu)
          } else {
            return ['livechat'].includes(menu)
          }
        }
      } else if (this.selectedBot.theme == 'toa' && this.selectedBot.pagerole == 'livechat') {
        this.$router.push('livechat')
        return ['livechat'].includes(menu)
      } else if (['101836095321926', '367570166993820'].includes(this.selectedBot.pageid)) {
        if (this.$store.state.privilege && this.$store.state.privilege.mjd_management == true) {
          return true
        } else {
          this.$router.push('template')
          return ['template'].includes(menu)
        }
      } else if ([...this.$store.state.lamyPage].includes(this.selectedBot.pageid)) {
        // Lamy
        if (this.$store.state.privilege && this.$store.state.privilege.role == 'staff') {
          return ['template'].includes(menu)
        } else {
          return true
        }
      } else if (this.selectedBot.theme == 'webchat') {
        return !['template'].includes(menu)
      } else if (this.selectedBot.type === 'yasale-ac') {
        if (this.$store.state.privilege && this.$store.state.privilege.role === 'superadmin') {
          return true
        } else return ['template'].includes(menu)
      } else if (this.$store.state.menubypageid[this.selectedBot.pageid]) {
        return this.$store.state.menubypageid[this.selectedBot.pageid].includes(menu)
        // } else if([...this.$store.state.shoptheme].includes(this.selectedBot.theme)) { //Shop theme
        //   return !['agentmanagement'].includes(menu)
      } else if (this.selectedBot.theme == 'secap') {
        if (this.$store.state.privilege.role == 'admin') {
          return ['template'].includes(menu)
        } else {
          return true
        }
      } else if (this.selectedBot.theme == 'warroom') {
        if (this.$localStorage.get('app_type') === 'warroom') {
          return ['TrueidSystemMaintenance'].includes(menu)
        }
        return true
      } else {
        return true
      }
    },
    onGoHome() {
      location.href = '/' + this.$i18n.locale() + '/allbots'
    },
    clickAds() {
      var prefix = window.location.hostname == 'cms.zwiz.ai' ? 'z_' : ''
      this.$ga.event('event', prefix + 'banner_5999', this.selectedBot.pagename)
      this.$router.push('upgrade')
    },
    ticket2checkstatus() {
      return new Promise((resolve) => {
        api.ticket2checkstatus(
          { adminId: this.$store.state.userid, pageid: this.selectedBot.pageid },
          (err, response) => {
            if (response.status) {
              resolve(true)
            } else {
              resolve(false)
            }
          }
        )
      })
    },
    logout: async function () {
      var vm = this
      var text = vm.$t('Do you want to Logout?')

      if (['studio7', 'ustore', 'ticket2'].includes(vm.selectedBot.theme)) {
        var isCheckout = await this.ticket2checkstatus()
        if (!isCheckout) {
          text = 'หากคุณลงชื่อออก ระบบจะทำการ Checkout ด้วย'
        }
      }

      vm.$swal
        .fire({
          title: text,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(async (result) => {
          if (result.value) {
            if (['studio7', 'ustore', 'ticket2'].includes(vm.selectedBot.theme) && !isCheckout) {
              await vm.ticket2checkincheckout('check-out')
              await vm.$swal.fire({
                type: 'success',
                text: 'ลงชื่อออกและ Checkout สำเร็จ'
              })
            }
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            if (isFacebook) {
              vm.$router.push('/' + vm.currentLang + '/login')
            } else {
              vm.$router.push('/' + vm.currentLang + '/nigol')
            }
          }
        })
    },
    ticket2checkincheckout(actions) {
      return new Promise((resolve) => {
        var data = {
          adminId: this.$store.state.userid,
          pageid: this.selectedBot.pageid,
          actions // check-in หรือ check-out
        }
        api.ticket2checkincheckout(data, (err, response) => {
          if (response.responsecode == 200) {
            resolve()
          }
        })
      })
    },
    selectBot: function (page) {
      var vm = this
      vm.$store.dispatch('loading')
      $.each(vm.botlist, function (index, bot) {
        if (page.value === bot.pageid) {
          vm.$store.dispatch('selectBot', bot)
        }
      })
      location.reload()
    },
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    show(e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    getSetting: function (callback) {
      let vm = this
      var data = {
        pageid: vm.$store.state.selectedBot.pageid
      }

      api.getSetting(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }

        var contents = {}
        $.each(response.data, function (index, val) {
          contents[val.contenttype] = val
        })
        callback(contents)
      })
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      // vm.$store.dispatch('loading')
      let data = {
        pageid: vm.selectedBot.pageid
      }

      var message = null
      var generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ]
      var messages = null
      var type = 'json'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          type = response.data.type
          if (type === 'message') {
            messages = [
              [
                {
                  text: response.data.message_text,
                  type: 'text'
                }
              ]
            ]
          } else if (type === 'generic') {
            messages = [[]]
            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              $.each(response.data.message, function (index, val) {
                generics[index] = val
              })

              messages[0][0] = {
                type: 'generic',
                data: generics,
                ratio: response.data.ratio == 'horizontal' ? 'horizontal' : 'square'
              }
            }
          } else {
            if (vm.isJsonParseable(response.data.message)) {
              messages = JSON.parse(response.data.message)
            }
          }
          type = 'json'
        }
        callback({
          type: type,
          message: message,
          generics: generics,
          messages: messages
        })
      })
    },
    toggleBotStatus: async function () {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.botStatus = bot.status
      this.$store.dispatch('loading')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layouts/MenuList/MainMenuList.js